import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    bannerTitle: '利用規約',
  },
});

export const meta: PageMeta = {
  title: strings.bannerTitle,
  order: 3,
};
